import { render } from "./ListAlphabetic.vue?vue&type=template&id=5d6b4d00"
import script from "./ListAlphabetic.vue?vue&type=script&lang=js"
export * from "./ListAlphabetic.vue?vue&type=script&lang=js"
script.render = render

export default script